import {useEffect, useRef, useState} from "react";
import {Button, ButtonGroup, Card, CardGroup, Dropdown, Modal} from "semantic-ui-react";
import {useAppDispatch} from "../../app/hooks";
import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {ChangeSelectedCompany} from "../Auth/AuthActions";
import {DeleteTemplate, GetAllCompanyData, GetAllTemplates, RenameTemplate} from "../CompanyDataTables/TablesActions";
import {ImportXmlFromTemplate} from "./ImportXMLActions";
import { useTranslation } from "react-i18next";

interface IDpiModal {
  open: boolean;
  onClose: () => void;
  handleImportXML: (e: any) => void;
  fromNewBtn: boolean;
  handleNewLabel: () => void;
}
export const ImportModal = ({open, onClose, handleImportXML, fromNewBtn, handleNewLabel}: IDpiModal) => {
  const {companyId, companyName} = useSelector((state: RootState) => state.auth);
  const templates = useSelector((state: RootState) => state.refData.templates);
  const dispatch = useAppDispatch();
  const inputFile = useRef<HTMLInputElement>(null);
  const {t} = useTranslation();
  const onHide = () => {
    onClose();
  };
  const {role} = useSelector((state: RootState) => state.auth);

  const rights = useSelector((state: RootState) => state.auth.rights);
  const rightsOptions = rights.map((company) => {
    return {key: company.companyId, text: company.companyName, value: company.companyId};
  });
  const [selectedCompany, setSelectedCompany] = useState(companyId);
  const handleDropdownChange = (e: any, data: any) => {
    dispatch(ChangeSelectedCompany(data.value)).then(() => {
      setSelectedCompany(data.value);
      dispatch(GetAllCompanyData(data.value));
    });
  };
  const handleDeleteTemplate = (recid: string, e: any) => {
    e.stopPropagation();
    if(editingTemplateId && editingTemplateId === recid) {
      handleBlur(e, recid, headerText);
    }
    dispatch(DeleteTemplate(recid, companyId));
  };
  const handleCardClick = (recid: string, templateName: string) => {
    dispatch(ImportXmlFromTemplate(recid, templateName, fromNewBtn));
    onHide();
  };

  useEffect(() => {
    if(!fromNewBtn){
      if (companyId === -1) return;
      dispatch(GetAllTemplates(companyId));
    } else {
      dispatch(GetAllTemplates(-1));
    }
  }, [companyId, dispatch, fromNewBtn]);

  const [editingTemplateId, setEditingTemplateId] = useState<string | null>(null);
  const [headerText, setHeaderText] = useState<string>("");

  const handleDoubleClick = (e: any, recid: string) => {
    e.stopPropagation();
    setEditingTemplateId(recid);
    setHeaderText(e.target.innerText);
  };

  const handleChange = (e: any) => {
    e.stopPropagation();
    setHeaderText(e.target.value);
  };

  const handleBlur = (e: any, id: string, previosName: string) => {
    e.stopPropagation();
    setEditingTemplateId(null);
    if (!headerText || headerText === "" || headerText === previosName) return;
    dispatch(RenameTemplate(id, headerText.replace(/[^a-zA-Z0-9 _!@#$%^&*()+=-]/g, ""), companyId));
  };
  return (
    <Modal closeIcon onClose={onHide} open={open} >
      <Modal.Header style={{display: "flex"}}>
        {/* {t("import_templates")} */}
        {fromNewBtn ? t("new_template") : t("open_templates")}
        {!fromNewBtn && <ButtonGroup color="blue" basic compact style={{marginLeft: "auto"}}>
          <Dropdown button text={companyName} style={{fontWeight: "bold"}} options={rightsOptions} value={selectedCompany} onChange={handleDropdownChange} />
        </ButtonGroup>}
      </Modal.Header>
      <Modal.Content>
        <CardGroup itemsPerRow={3}>
          <Card
            color="blue"
            style={{width: 260, height: 275}}
            onClick={() => {
              inputFile.current?.click();
            }}
          >
            {!fromNewBtn ? <Card.Content
              header={
                <>
                  {t("open_from_device")}
                  <input style={{display: "none"}} type="file" ref={inputFile} onChange={handleImportXML} />
                </>
              }
              style={{textAlign: "center", justifyContent: "center", display: "flex", alignItems: "center", fontWeight: "bold"}}
            />
          :
          <Card.Content
              header={
                <>
                  {t("empty_template")}
                </>
              }
              onClick={handleNewLabel}
              style={{textAlign: "center", justifyContent: "center", display: "flex", alignItems: "center", fontWeight: "bold"}}
            />}
          </Card>
          {templates &&
            templates.map((template: any, idx: any) => (
              <Card key={template.recid + idx.toString()} style={{width: 260, height: 275}} onClick={() => handleCardClick(template.recid, template.name)}>
                <Card.Content style={{overflow: "hidden", backgroundColor: "#ececec"}}>
                  {!fromNewBtn && (role === "admin" || role === "super_admin") && <><Button size="small" compact color="red" basic icon="trash alternate outline" style={{position: "absolute", right: 0, top: 3}} onClick={(e) => handleDeleteTemplate(template.recid, e)} />
                  <Button
                    size="small"
                    compact
                    color="black"
                    basic
                    icon="i cursor"
                    style={{position: "absolute", right: 0, top: 35}}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      setEditingTemplateId(template.recid);
                      setHeaderText(template.name);
                    }}
                  /></>}
                  <img
                    src={`data:image/png;base64,${template.imgPreview.fileContents}`}
                    alt="template preview"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </Card.Content>
                <Card.Content>
                  <Card.Header style={{display: "flex", justifyContent: "space-between"}}>
                    {!fromNewBtn && editingTemplateId && editingTemplateId === template.recid ? (
                      <input
                        id={"headerInput" + idx.toString() + template.recid}
                        autoFocus
                        value={headerText}
                        onClick={(e) => e.stopPropagation()}
                        onChange={handleChange}
                        onBlur={(e) => handleBlur(e, template.recid, template.name)}
                        onFocus={(e) => e.target.select()}
                        onKeyDown={(e: any) => {
                          if (e.key === "Enter") {
                            handleBlur(e, template.recid, template.name);
                          }
                        }}
                        style={{flex: 1}}
                      />
                    ) : (
                      <div onClick={(e) => handleDoubleClick(e, template.recid)}>{template.name}</div>
                    )}
                  </Card.Header>
                  {!fromNewBtn && <Card.Meta>
                    <span className="date">{new Date(template.lastmodified).toLocaleDateString()}</span>
                  </Card.Meta>}
                  {!fromNewBtn && <Card.Description>{template.lastmodifiedby || ""}</Card.Description>}
                </Card.Content>
              </Card>
            ))}
        </CardGroup>
      </Modal.Content>
    </Modal>
  );
};
